var exports = {
  "k": "xcc377c0b--00bec3--container",
  "q": "xcc377c0b--00bec3--sales-start",
};

module.exports = exports;
